import { render, staticRenderFns } from "./Aftersaleslist.vue?vue&type=template&id=982af182&"
import script from "./Aftersaleslist.vue?vue&type=script&lang=js&"
export * from "./Aftersaleslist.vue?vue&type=script&lang=js&"
import style0 from "./Aftersaleslist.vue?vue&type=style&index=0&id=982af182&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('982af182')) {
      api.createRecord('982af182', component.options)
    } else {
      api.reload('982af182', component.options)
    }
    module.hot.accept("./Aftersaleslist.vue?vue&type=template&id=982af182&", function () {
      api.rerender('982af182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/Aftersaleslist.vue"
export default component.exports